export enum DeliveryStatus {
  PENDING = 1,
  // Status STARTED = 2 will not be used as a filter yet
  FINISHED = 3,
}
